import SafariStub from "../SafariStub";

function Nyerere() {
  return (
    <SafariStub
      title="Nyerere National Park"
      lead="River safari country with boat days, walking options in selected areas, and a remote southern feel."
      points={[
        "Boat safaris along the Rufiji system",
        "Quieter camps and wide wilderness",
        "Strong as a standalone southern trip",
      ]}
      parentTo={"/safaris/southern-circuits"}
      parentLabel="Southern Circuit"
    />
  );
}

export default Nyerere;
